import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import session components (lazy-loaded for performance)
const SessionTypesPage = React.lazy(() => import("./SessionTypes").then(module => ({ default: module.SessionTypesPage })));
const CreateSessionType = React.lazy(() => import("./CreateSessionType").then(module => ({ default: module.CreateSessionType })));
const EditSessionType = React.lazy(() => import("./EditSessionType").then(module => ({ default: module.EditSessionType })));
const SetAvailabilities = React.lazy(() => import("./SetAvailabilities").then(module => ({ default: module.SetAvailabilities })));
const ScheduleSession = React.lazy(() => import("./ScheduleSession").then(module => ({ default: module.ScheduleSession })));
const ClientBookingCalendar = React.lazy(() => import("./ClientBookingCalendar").then(module => ({ default: module.ClientBookingCalendar })));
const BookingDetails = React.lazy(() => import("./BookingDetails").then(module => ({ default: module.BookingDetails })));
const ClientBookingCalendarByPractitionerId = React.lazy(() => import("./ClientBookingCalendarByPractitionerId").then(module => ({ default: module.ClientBookingCalendarByPractitionerId })));

const sessionsModuleConfig: ModuleConfig = {
    // 🏷️ MODULE IDENTITY
    id: "sessions",
    name: "Session Booking",
    description: "Schedule and manage client sessions and appointments",
    version: "1.3.0",
    enabled: true,
    category: "scheduling",
    order: 3,
    icon: "📅",
    color: "#3182CE",

    // 🛣️ ROUTES
    routes: [
        {
            path: "/sessions/types",
            component: SessionTypesPage,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/sessions/types/create",
            component: CreateSessionType,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/sessions/edit/:id",
            component: EditSessionType,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/sessions/set-availabilities",
            component: SetAvailabilities,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/sessions/set-availabilities/:practitionerId",
            component: SetAvailabilities,
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            path: "/sessions/practitioner-calendar/:practitionerId",
            component: ClientBookingCalendarByPractitionerId,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/schedule-session",
            component: ScheduleSession,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/sessions/client-booking-calendar",
            component: ClientBookingCalendar,
            permissions: ["USER", "ADMIN", "MANAGER"]
        },
        {
            path: "/bookings/:bookingId",
            component: BookingDetails,
            permissions: ["USER", "ADMIN", "MANAGER"]
        }
    ],

    // 🧭 NAVIGATION
    navigation: [
        {
            label: "My Bookings",
            path: "/sessions/client-booking-calendar",
            icon: "📋",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "Session Types",
            path: "/sessions/types",
            icon: "🎯",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "Create Session Type",
            path: "/sessions/types/create",
            icon: "➕",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "Set Availability",
            path: "/sessions/set-availabilities",
            icon: "⏰",
            permissions: ["ADMIN", "MANAGER"]
        },
        {
            label: "Schedule Session",
            path: "/schedule-session",
            icon: "📅",
            permissions: ["ADMIN", "MANAGER"]
        }
    ],

    // 🔐 PERMISSIONS
    permissions: {
        view: ["USER", "ADMIN", "MANAGER"],
        create: ["ADMIN", "MANAGER"],
        edit: ["ADMIN", "MANAGER"],
        delete: ["ADMIN"]
    },

    // ⚡ QUICK ACTIONS
    quickActions: [
        {
            label: "Book Session",
            path: "/schedule-session",
            icon: "📅",
            description: "Schedule a new session with a client"
        },
        {
            label: "Create Session Type",
            path: "/sessions/types/create",
            icon: "🎯",
            description: "Create a new type of session offering"
        },
        {
            label: "Set Availability",
            path: "/sessions/set-availabilities",
            icon: "⏰",
            description: "Update your available booking times"
        }
    ]
};

export default sessionsModuleConfig;